import { SearchInput } from "@amzn/storm-ui";
import {
    type ChangeEvent,
    type KeyboardEvent,
    type ReactElement,
    useRef,
} from "react";
import { useStore } from "zustand";

import { FeatureFlags, FeatureFlagsStore } from "../../../store/featureFlags";
import { unifiedFilterStore } from "../../../store/unifiedFilters";

export const SEARCH_BAR_ID = "search-input";

export const SearchBar = (): ReactElement => {
    const searchInputRef = useRef<HTMLInputElement>(null);

    const [
        unifiedSearchQuery,
        setUnifiedSearchQuery,
        setIsMetadataDirty,
        setIsAiSearchTriggered,
    ] = useStore(unifiedFilterStore, (state) => [
        state.searchQuery,
        state.setSearchQuery,
        state.setIsMetadataDirty,
        state.setIsAiSearchTriggered,
    ]);

    const isAiSearchEnabled = useStore(
        FeatureFlagsStore,
        (state) => state[FeatureFlags.AI_SEARCH],
    );

    const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
        const value = target.value ?? "";
        setUnifiedSearchQuery(value);
    };

    const handleClear = () => {
        setUnifiedSearchQuery("");
        setIsMetadataDirty(true);
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter" && isAiSearchEnabled) {
            setIsAiSearchTriggered(true);
        }
    };

    return (
        <SearchInput
            id={SEARCH_BAR_ID}
            data-testid="search-input"
            inputRef={searchInputRef}
            value={unifiedSearchQuery}
            onChange={handleChange}
            onClear={handleClear}
            onKeyDown={handleKeyDown}
            placeholder="Search"
            fullWidth={true}
        />
    );
};

export default SearchBar;
